/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Header } from "@/components/Header";
import "primeicons/primeicons.css";
import { Helmet } from "react-helmet";

import Home from "./home";
import Jobs from "./jobs";
import Cases from "./cases";
import Contato from "./Contato";
import { Footer } from "@/components/Footer";

const Index = () => {
  const scrollToId = (e, id) => {
    e.preventDefault();
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <>
      <Helmet>
        <title>Zest AG - The full responsa agency</title>

        <link rel="shortcut icon" href="https://www.zest.ag/favicon.png?v=3" />
		<link rel="icon" type="image/png" href="https://www.zest.ag/favicon.png?v=3" />
		<link rel="apple-touch-icon" href="https://www.zest.ag/favicon.png?v=3" />

        <meta name="description" content="Zest AG é uma agência full service que une estratégia, criação e execução para transformar ideias em resultados para marcas." />
        <meta name="keywords" content="Zest AG, agência full service, estratégia, criação, campanhas, conteúdo, eventos, marketing"/>
        <link rel="canonical" href="https://www.zest.ag/" />

        <meta property="og:url" content="https://zest.ag/" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Zest AG - The full responsa agency" />
        <meta property="og:description" content="Zest AG é uma agência full service que une estratégia, criação e execução para transformar ideias em resultados para marcas." />
        <meta property="og:image" content="https://zest.ag/avatar.jpg" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Zest AG - The full responsa agency" />
        <meta name="twitter:description" content="Zest AG é uma agência full service que une estratégia, criação e execução para transformar ideias em resultados para marcas." />
      </Helmet>

      <Header />

      <Home />
      <Jobs scrollToId={scrollToId} />
      <Cases />
      <Contato />

	  <Footer/>
    </>
  );
};

export default Index;
